import api from '../services/api';
import { $Q } from '../utils/query-selector';
import { createInterception } from '../utils/script-defer';
import { stringToHTML } from '../utils/to-html';
import { createSlider } from '../components/slider-component';
import { addTagScript } from '../utils/add-tag-script';
import { loadScriptProductCard } from './sections-defer';

/**
 * Render recommendation by API with product ID
 * @return void
 */
export async function getRecommendation({
  product,
  reference,
  section,
  onRender,
  scope,
}) {
  const html = await api.recommendationByApi(product, section);
  const recommendation = $Q(reference, stringToHTML(html));

  if (recommendation && recommendation.innerHTML.trim().length) {
    $Q(onRender, scope).innerHTML = recommendation.outerHTML;
  }
}

/**
 * Create interception on recommendation section
 * @returns void - build and slider after mount recommendation API
 */
export function recommendationAPI() {
  const reference = '#product-recommendation';
  const queryNode = $Q(reference);
  if (!queryNode) return;

  const {
    dataset: { product },
  } = queryNode;
  const section = reference.replace(/[#,]/g, '');

  createInterception(queryNode, async () => {
    if (!window.swiperScript) {
      await addTagScript(queryNode.dataset.script, 'swiperScript');
    }

    await getRecommendation({
      product,
      reference,
      section,
      onRender: '.shopify-section.recommendation',
    });

    const sliderUpsell = $Q('.slider-js.swiperElproductrecommendation');
    await loadScriptProductCard();
    await createSlider(sliderUpsell);
  });
}
